

const INITIAL_STATE = {
    events: null,
    connectedEvents: null,
    confirmedEvents: null,
    importedUsers: null,
    users: null,
    usersOnline: null,
  };

 



  function adminCounterReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case 'ADMIN_EVENTS_COUNTER' : {
        return ({
            ...state,
            events: action.payload
        });
      }
      case 'ADMIN_CONNECTED_EVENTS_COUNTER' : {
        return ({
            ...state,
            connectedEvents: action.payload
        });
      }
      case 'ADMIN_CONFIRMED_EVENTS_COUNTER' : {
        return ({
            ...state,
            confirmedEvents: action.payload
        });
      }
      case 'ADMIN_USERS_COUNTER' : {
        return ({
            ...state,
            users: action.payload
        });
      }
      case 'ADMIN_IMPORTEDUSERS_COUNTER' : {
        return ({
            ...state,
            importedUsers: action.payload
        });
      }
      case 'ADMIN_USERSONLINE_COUNTER' : {
        return ({
            ...state,
            usersOnline: action.payload
        });
      }
      

      
      default : return state;
    }
  }
  
  export default adminCounterReducer;



// WEBPACK FOOTER //
// ./src/reducers/adminCounter.js